import React from 'react';
import clsx from 'clsx';
import { Typography } from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { ReactComponent as StressIcon } from '../../../assets/calendar/head-flash.svg';
import './EventMetrics.scss';

interface EventMetricsProps {
  heartRate?: {
    startHRbpm: number;
    endHRbpm: number;
  };
  stress?: number;
  className?: string;
  size?: 'sm' | 'md';
}

export const EventMetrics: React.FC<EventMetricsProps> = ({
  heartRate,
  stress,
  className,
  size = 'md',
}) => {
  if (!heartRate && !stress) return null;

  return (
    <div className={clsx('event-metrics', `event-metrics--${size}`, className)}>
      {heartRate && (
        <div className="event-metrics__item">
          <FavoriteIcon className={clsx('event-metrics__icon', 'event-metrics__heart-rate')} />
          <Typography
            variant={size === 'sm' ? 'caption' : 'body2'}
            className={clsx('event-metrics__text', 'event-metrics__heart-rate')}
          >
            {Math.floor(heartRate.startHRbpm)} - {Math.floor(heartRate.endHRbpm)}
          </Typography>
        </div>
      )}
      {!!stress && (
        <div className="event-metrics__item">
          <StressIcon className="event-metrics__icon event-metrics__stress" />

          <Typography
            variant={size === 'sm' ? 'caption' : 'body2'}
            className={clsx('event-metrics__text', 'event-metrics__stress')}
          >
            {Math.floor(stress)}
          </Typography>
        </div>
      )}
    </div>
  );
};
